
import dayjsLib from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";

// extend plugins
dayjsLib.extend(utc);
dayjsLib.extend(timezone);
dayjsLib.extend(customParseFormat);

// export configured instance
export const dayjs = dayjsLib;


export const getMonthNumber = (monthName) => {
  const monthNames = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec",
  ];

  const index = monthNames.findIndex(
    (m) => m.toUpperCase() === monthName.toUpperCase()
  );

  return index !== -1 ? index + 1 : 0;
};


export const parseDate = (dateStr, format) => {
  if (!dateStr) return null;

  let day, month, year;
  let parts;

  if (format === "DD/MM/YYYY") {
    parts = dateStr.split("/");
    [day, month, year] = parts;
  }

  else if (format === "MM/DD/YYYY") {
    parts = dateStr.split("/");
    [month, day, year] = parts;
  }

  else if (format === "YYYY/MM/DD") {
    parts = dateStr.split("/");
    [year, month, day] = parts;
  }

  else if (format === "DD/MM/YY") {
    parts = dateStr.split("/");
    day = parts[0];
    month = parts[1];
    year = "20" + parts[2];
  }

  else if (format === "DD-MM-YYYY") {
    parts = dateStr.split("-");
    [day, month, year] = parts;
  }

  else if (format === "MM-DD-YYYY") {
    parts = dateStr.split("-");
    [month, day, year] = parts;
  }

  else if (format === "YYYY-MM-DD") {
    parts = dateStr.split("-");
    [year, month, day] = parts;
  }

  else if (format === "DD-MM-YY") {
    parts = dateStr.split("-");
    day = parts[0];
    month = parts[1];
    year = "20" + parts[2];
  }

  else if (format === "DD-MMM-YYYY" || format === "DD/MMM/YYYY") {
    parts = dateStr.split(/[-/]/);
    day = parts[0];
    month = getMonthNumber(parts[1]);
    year = parts[2];
  }

  return new Date(year, month - 1, day);
};

export const convertMomentTimeFormat = (format) => {
  if (!format) return "HH:mm:ss";

  if (format === "HH24:MI") return "HH:mm";
  if (format === "HH24:MI:SS") return "HH:mm:ss";

  if (format === "HH12:MI AM") return "hh:mm A";
  if (format === "HH12:MI:SS AM") return "hh:mm:ss A";

  return "HH:mm:ss";
};

export const convertMomentTimeSecoundsFormat = (format) => {
    if (format === "HH24:MI") return "HH:mm:ss";    
    if (format === "HH12:MI AM") return "hh:mm:ss A"; 
    return "hh:mm:ss A";
};

// for react timepicker
export const convertTimeFormat = (format) => {
  if (!format) return "HH:mm";

  if (format === "HH12:MI AM") return "hh:mm a";
  if (format === "HH12:MI:SS AM") return "hh:mm:ss a";

  if (format === "HH24:MI") return "HH:mm";
  if (format === "HH24:MI:SS") return "HH:mm:ss";

  return "HH:mm";
};